import { CompareActor } from "src/components/CompareChangesModal/types";
import { getFullName } from "src/helpers/userHelper";

/** A draft's updatedBy user as selected by the compare-changes queries. */
export interface DraftUpdatedByUser {
  givenName: string;
  familyName: string;
  metadata: { picture?: string } | null;
}

/**
 * Draft attribution for the changes column header. Hidden entirely (undefined)
 * when the user is unresolvable or has no name — never an empty label.
 */
export const toLastEditedBy = (
  user: DraftUpdatedByUser | null | undefined,
): CompareActor | undefined => {
  if (!user) {
    return undefined;
  }
  const name = getFullName(user);
  if (!name) {
    return undefined;
  }
  return { name, avatarUrl: user.metadata?.picture || undefined };
};
